import type { HeadFC } from 'gatsby';
import * as React from 'react';
import DefaultLayout from '../components/layouts/DefaultLayout';
import SignUpForm from '../components/organisms/SignUpForm';

const GetStartedPage = () => {
  return (
    <DefaultLayout hideGetStartedLink hideFooter>
      <main className="container flex flex-col items-center mt-16 text-center lg:mt-24">
        <h1 className="text-4xl leading-[44px] lg:text-6xl lg:leading-[72px] font-semibold text-slate-900 tracking-tight mb-4 lg:mb-6 max-w-5xl mx-auto font-display text-balance">
          Get started for free
        </h1>
        <p className="max-w-5xl mx-auto mb-12 text-lg lg:text-xl text-slate-600 text-balance">
          No credit card, no set-up fees. Completely free.
        </p>

        <div className="relative w-full max-w-xl px-6 pt-10 pb-6 overflow-hidden text-left lg:p-16 lg:px-16 lg:pt-16 lg:pb-12 bg-slate-50 rounded-3xl">
          <SignUpForm formId="get_started_page" />
        </div>

        <div className="flex flex-col items-center gap-8 mt-10 mb-6 lg:mt-16">
          <div className="grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-2 xl:grid-cols-4">
            <div className="flex items-center justify-center">
              <img src="/logos/cap.png" alt="Civil Air Patrol" className="h-10" />
            </div>
            <div className="flex items-center justify-center">
              <img src="/logos/cal-aero.png" alt="Cal Aero" className="h-12" />
            </div>
            <div className="flex items-center justify-center">
              <img src="/logos/air-merino.png" alt="Air Merino" className="h-9" />
            </div>
            {/*<div className="flex items-center justify-center">*/}
            {/*  <img src="/logos/honda-airways.png" alt="Honda Airways" className="h-6" />*/}
            {/*</div>*/}
            {/*<div className="flex items-center justify-center">*/}
            {/*  <img src="/logos/fits-air.png" alt="FitsAir" className="h-11" />*/}
            {/*</div>*/}
            <div className="flex items-center justify-center">
              <img src="/logos/fafa.png" alt="Flying Angel's Flight Academy" className="h-12" />
            </div>
          </div>
        </div>

        <div className="relative hidden w-full max-w-5xl mt-16 overflow-hidden lg:block">
          <div className="h-[500px] w-full">
            <img
              src="/tailplane-screenshot-schedule.png"
              alt="Tailplane Schedule"
              className="absolute top-0 left-0 right-0 rounded-tr-[10px] rounded-tl-[10px] border-x-[4px] border-t-[4px] border-slate-900"
            />
          </div>
        </div>
        <div className="relative block w-full max-w-5xl mt-16 lg:hidden">
          <img
            src="/tailplane-screenshot-schedule.png"
            alt="Tailplane Schedule"
            className="border-[4px] border-slate-900  rounded-[12px]"
          />
        </div>
      </main>

      <footer className="pb-12">
        <div className="container flex flex-col-reverse items-start justify-between gap-6 pt-8 border-t lg:items-center lg:flex-row border-slate-200">
          <p className="text-slate-500">&copy; {new Date().getFullYear()} Tailplane. All rights reserved.</p>
        </div>
      </footer>
    </DefaultLayout>
  );
};

export default GetStartedPage;

export const Head: HeadFC = () => (
  <>
    <title>Sign up to Tailplane</title>
    <link rel="canonical" href="https://tailplane.com/get-started" />
  </>
);
